import React, { Component } from "react";
import { Orders } from "baseparking-api";
import moment from "moment";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Table from "components/Table/Table.jsx";
import TablePagination from '@material-ui/core/TablePagination';
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Tooltip from '@material-ui/core/Tooltip';
import Search from "@material-ui/icons/Search";
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';

import OrderDetails from './OrderDetails';

function formatISK(price) {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

function debounce(a, b, c) { var d, e; return function () { function h() { d = null, c || (e = a.apply(f, g)) } var f = this, g = arguments; return clearTimeout(d), d = setTimeout(h, b), c && !d && (e = a.apply(f, g)), e } }

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    actionButton: {
        margin: "0 0 0 5px",
        padding: "5px",
        "& svg,& .fab,& .fas,& .far,& .fal,& .material-icons": {
            marginRight: "0px"
        },
        float: 'right'
    },
    addService: {
        float: 'right'
    },
    flex: {
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end',
        // flexWrap: 'wrap',
    },
    viewButton: {
        height: '15px',
        width: '15px',
        padding: '15px',
        margin: 0,
    },
    invoiceButton: {
        height: '15px',
        width: '140px',
        padding: '15px',
        margin: '0 10px 0 0',
    },
    viewButtonIcon: {
        top: '0px !important',
        left: '2px !important',
    },
    input: {
        position: 'absolute',
        right: '10px',
        top: 0,
        color: 'white',
    },
    loaderContainer: {
        height: '607px',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
};

class OrdersView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            orderPreview: null,

            search: '',
            page: 0,
            rowsPerPage: 10,
        }
    }

    componentWillMount() {
        this.refreshOrders();
    }

    refreshOrders = () => {
        const { search, page, rowsPerPage } = this.state;
        const { classes } = this.props;

        Orders.get(search, rowsPerPage, page)
            .then(res => {
                if (res.data.count) {
                    this.setState({ count: res.data.count });
                }
                const bookingData =
                    res.data.orders &&
                    res.data.orders.map((o, key) => [
                        moment(o.dateCreated).format('DD-MM-YYYY HH:mm:ss'),
                        o.vehicle.reg,
                        `${o.coupons.length ? '🔖 ' : o.client.vip ? '🏆 ' : o.client.senior ? '👵 ' : ''}${o.client.name}`,
                        formatISK(o.totalPrice.toString()) + ' kr.',
                        o.client.vip ? `VIP - ${o.client.vip}%` : o.coupons.length ? `${o.coupons[0].labelThen} - ${o.coupons[0].discountThen}%` : o.client.senior ? 'Eldrib. - 10%' : '',
                        o.stay.duration.toString() + " dagar",
                        o.services ? o.services.map(s => s.labelThen).join(',') : " ",
                        o.status === 'due' ? 'Ógreitt' : (o.arrived ? o.returned ? 'Bókun afgreidd' : 'Bíll á plani' : 'Bíll væntanlegur'),
                        // o.services ? o.services.map(s => s.labelThen).join(',') : " ", !o.arrived ? "Ókominn" : "Kominn",
                        <div className={classes.buttons}>
                            {o.status !== 'paid' &&
                                <Tooltip title='Færa í afgreiðslu'>
                                <Button className={classes.invoiceButton} onClick={e => this.handleOrderInvoicing(o)}>
                                    Færa í afgreiðslu
                                </Button>
                            </Tooltip>}
                            <Tooltip title='Skoða Pöntun'>
                                <Button className={classes.viewButton} color='warning' onClick={e => this.setState({ orderPreview: o })}>
                                    <Search className={classes.viewButtonIcon} />
                                </Button>
                            </Tooltip>
                        </div>
                    ]);

                this.setState({ orders: bookingData, loading: false });
            })
            .catch(err => console.log(err))
    }

    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage }, () => this.refreshOrders());
    }

    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: event.target.value }, () => this.refreshOrders());
    }

    setSearchTerm = debounce(search => {
        this.setState({ loading: true });
        this.setState({ search, page: 0 }, () => this.refreshOrders());
    }, 600)

    handleOrderInvoicing = (order) => {
        Orders.invoice(order)
            .then(res => {
                console.log('Has been processed');
                this.refreshOrders();
            })
            .catch(err => {

            }) 
    }


    render() {
        const { classes } = this.props;
        const { loading, orderPreview } = this.state;

        return (
            <GridContainer>
                <OrderDetails open={!!orderPreview} onClose={e => this.setState({ orderPreview: null })} order={orderPreview} />
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="info">
                            <h4 className={classes.cardTitleWhite}>Bókanir</h4>
                            <p className={classes.cardCategoryWhite}>Hér má finna allar bókanir Smart Parking í þeirri röð sem þær bárust</p>
                            <TextField
                                id="outlined-email-input"
                                label="Leit"
                                className={classes.input}
                                onChange={e => this.setSearchTerm(e.target.value)}
                                type="text"
                                name="Leit"
                                margin="normal"
                                variant="outlined"
                            />
                        </CardHeader>
                        <CardBody>
                            {
                                loading ?
                                    <div className={classes.loaderContainer}>
                                        <CircularProgress className={classes.loader} />
                                    </div>
                                    :
                                    <Table
                                        tableHeaderColor="warning"
                                        tableHead={["Dagsetning", "Bílnúmer", "Nafn", "Upphæð", "Afsláttur", "Geymslulengd", "Þjónustur", "Staða"]}
                                        tableData={this.state.orders}
                                    />

                            }
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={this.state.count}
                                rowsPerPage={this.state.rowsPerPage}
                                page={this.state.page}
                                labelRowsPerPage={'Bókanir á síðu:'}
                                backIconButtonProps={{
                                    'aria-label': 'Fyrri síða',
                                }}
                                nextIconButtonProps={{
                                    'aria-label': 'Næsta síða',
                                }}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                            />
                        </CardBody>
                    </Card>
                </GridItem>
                {/* <GridItem xs={12} sm={12} md={12}>
          <Card plain>
            <CardHeader plain color="primary">
              <h4 className={classes.cardTitleWhite}>
                Table on Plain Background
            </h4>
              <p className={classes.cardCategoryWhite}>
                Here is a subtitle for this table
            </p>
            </CardHeader>
            <CardBody>
              <Table
                tableHeaderColor="primary"
                tableHead={["ID", "Name", "Country", "City", "Salary"]}
                tableData={[
                  ["1", "Dakota Rice", "$36,738", "Niger", "Oud-Turnhout"],
                  ["2", "Minerva Hooper", "$23,789", "Curaçao", "Sinaai-Waas"],
                  ["3", "Sage Rodriguez", "$56,142", "Netherlands", "Baileux"],
                  [
                    "4",
                    "Philip Chaney",
                    "$38,735",
                    "Korea, South",
                    "Overland Park"
                  ],
                  [
                    "5",
                    "Doris Greene",
                    "$63,542",
                    "Malawi",
                    "Feldkirchen in Kärnten"
                  ],
                  ["6", "Mason Porter", "$78,615", "Chile", "Gloucester"]
                ]}
              />
            </CardBody>
          </Card>
        </GridItem> */}
            </GridContainer>

        )
    }
}


export default withStyles(styles)(OrdersView);



// WEBPACK FOOTER //
// ./src/views/Orders/Orders.jsx